import { queryOptions } from "@tanstack/react-query";
import { listOrganizations } from "api-client";

export interface OrganizationMembersQueryInput {
  pageIndex: number;
  pageSize: number;
  query: string;
}

export interface OrganizationAthletesQueryInput extends OrganizationMembersQueryInput {
  status: "active" | "archived";
}

export const organizationKeys = {
  all: ["organizations"] as const,
  list: () => {
    return [...organizationKeys.all, "list"] as const;
  },
  athletes: (organizationId: string) => {
    return [
      ...organizationKeys.all,
      "detail",
      organizationId,
      "athletes",
    ] as const;
  },
  athleteList: (
    organizationId: string,
    input: OrganizationAthletesQueryInput,
  ) => {
    return [...organizationKeys.athletes(organizationId), input] as const;
  },
  members: (organizationId: string) => {
    return [
      ...organizationKeys.all,
      "detail",
      organizationId,
      "members",
    ] as const;
  },
  memberList: (
    organizationId: string,
    input: OrganizationMembersQueryInput,
  ) => {
    return [...organizationKeys.members(organizationId), input] as const;
  },
};

export function organizationsQueryOptions() {
  return queryOptions({
    queryKey: organizationKeys.list(),
    queryFn: async () => {
      const response = await listOrganizations();
      return response.data.data.organizations;
    },
  });
}
